import './App.css';
import ContextualProvider from './components/contextMenus/ContextualProvider';
import { ViewportProvider } from './contexts/ViewportContext';
import PageWrapper from './pages/PageWrapper';
import LoginPage from './pages/LoginPage';
import { useInitUserSettings } from './hooks/userSettings/useInitUserSettings';
import { useLogIn } from './hooks/authentication/useLogIn';
import SnackbarContext from './contexts/SnackbarContext';
import CustomThemeProvider from './contexts/CustomThemeContext';
import { useSelector } from 'react-redux';
import { isAuthenticating, isPremiumAccount } from './reducers/authState';
import NoPremiumPage from './pages/NoPremiumPage';

function App() {
  const authInfo = useLogIn();
  const authenticating = useSelector(isAuthenticating);
  const premiumAccount = useSelector(isPremiumAccount);
  useInitUserSettings();

  return (
    <CustomThemeProvider>
      <ViewportProvider>
        <ContextualProvider>
          <SnackbarContext>
          {
              authInfo.accessToken && !authenticating ?
              premiumAccount ?
              <PageWrapper /> :
              <NoPremiumPage /> :
              <LoginPage authUrl={authInfo.authUrl} authenticating={authenticating} />
          }
          </SnackbarContext>
        </ContextualProvider>
      </ViewportProvider>
    </CustomThemeProvider>
  );
}

export default App;
